import { createPhaseAction } from 'src/helpers/redux'
import { IState } from './state'
import { IGetCallHistoryParams } from 'src/services/communication/twilio'
import { IObjectFullfiledActionPayload } from '../storage/objects/actions'

export const PREFIX = 'communication'
export const SAGA = `${PREFIX}/saga`

export interface IAcceptCall {
  microMute?: boolean
  callHolded?: boolean
}

export interface IOutgoingCall {
  number: string
}

export const actions = {
  setTwillioState: createPhaseAction<boolean>(`${SAGA}/setTwillioState`),
  getHistoryCalls: createPhaseAction<IGetCallHistoryParams>(
    `${SAGA}/getHistoryCalls`
  ),
  getActiveCalls: createPhaseAction<IGetCallHistoryParams>(
    `${SAGA}/getActiveCalls`
  ),
  runActiveCallsAutoClear: createPhaseAction<void>(
    `${SAGA}/runActiveCallsAutoClear`
  ),
  setActiveCallsClose: createPhaseAction<{ id: number }>(
    `${SAGA}/setActiveCallsClose`
  ),

  setHistoryCallsUpdateObject: createPhaseAction<IObjectFullfiledActionPayload>(
    `${SAGA}/getHistoryCallsUpdateObject`
  ),
  fetchMoreHistoryCalls: createPhaseAction<IGetCallHistoryParams>(
    `${SAGA}/fetchMoreHistoryCalls`
  ),
  setWidgetOptions: createPhaseAction<IState['widgetOptions']>(
    `${SAGA}/setWidgetState`
  ),
}

export type Actions = typeof actions
